import React from 'react';
import styled from 'styled-components';
import { Heading } from '@amzn/storm-ui';

const RegistrationPageTitleWrapper = styled(Heading)`
  && {
    display: flex;
    justify-content: center;
    margin-block-end: ${({ theme }) => theme.spacing.large.default};
  }
`;
interface CreateAccountTitleProps {
  title: string;
}

const RegistrationTitle = ({ title }: CreateAccountTitleProps) => {
  return (
    <RegistrationPageTitleWrapper renderAs="h1" size="xxlarge">
      {title}
    </RegistrationPageTitleWrapper>
  );
};

export default RegistrationTitle;
